import { render, staticRenderFns } from "./AdminZipCodes.vue?vue&type=template&id=7a4647e2&scoped=true&"
import script from "./AdminZipCodes.vue?vue&type=script&lang=js&"
export * from "./AdminZipCodes.vue?vue&type=script&lang=js&"
import style0 from "./AdminZipCodes.vue?vue&type=style&index=0&id=7a4647e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4647e2",
  null
  
)

export default component.exports